import "./style.scss";

import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import { deleteIntegration } from "store/integrationsStore";
import { useAppDispatch } from "store/store";

import type { TDisconnectModal } from "../types";

interface IDisconnectModal {
    data: TDisconnectModal;
    onClose: () => void;
}

const DisconnectModal = ({ data, onClose }: IDisconnectModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const onDelete = async () => {
        const response = await dispatch(deleteIntegration(data.id as number));
        if (response.meta.requestStatus === "fulfilled") {
            onClose();
        }
    };

    return (
        <ModalBox open={data.open} onClose={onClose} mainTitle={`Désactiver ${data.integrationName}`}>
            <div className="integration-disconnect-modal">
                <div className="integration-disconnect-modal-body">
                    <span>{data.warningText}</span>
                    <span>{t("IntegrationsSettings.DisconnectConfirm")}</span>
                </div>
                <div className="btn-wrapper">
                    <StyledButton buttonType="danger" fullWidth onClick={onDelete}>
                        {t("IntegrationsSettings.YesDisconnect")}
                    </StyledButton>
                    <StyledButton buttonType="secondary" fullWidth onClick={onClose}>
                        {t("IntegrationsSettings.NoCancel")}
                    </StyledButton>
                </div>
            </div>
        </ModalBox>
    );
};

export default DisconnectModal;
